import { openBlock as s, createElementBlock as c, normalizeStyle as o, normalizeClass as i, createElementVNode as d, toDisplayString as g } from "vue";
const u = (t, a) => {
  const e = t.__vccOpts || t;
  for (const [r, n] of a)
    e[r] = n;
  return e;
}, _ = {
  name: "LandingBadge",
  props: {
    text: {
      type: String,
      required: !0,
      default: ""
    },
    theme: {
      type: String,
      required: !1,
      default: ""
    },
    accentColor: {
      type: String,
      required: !1,
      default: ""
    }
  },
  computed: {
    styles() {
      return {
        "--badge-accent-color": this.accentColor
      };
    },
    badgeTheme() {
      return this.accentColor ? "light" : ["light", "brand", "sale", "sale-dark"].includes(this.theme) ? this.theme : "light";
    }
  }
}, h = ["aria-label"];
function m(t, a, e, r, n, l) {
  return s(), c("div", {
    style: o(l.styles),
    class: i(["badge", `badge--${l.badgeTheme}`, {
      "badge--has-color": !!e.accentColor
    }])
  }, [d("span", {
    "aria-label": e.text
  }, g(e.text), 9, h)], 6);
}
const b = /* @__PURE__ */ u(_, [["render", m]]);
export {
  b as default
};
